import {put, select} from 'redux-saga/effects';

import {GameSelectors} from '../reducers/game_reducer';
import * as AlphaUtils from '../../utils/alpha';
import * as GameActions from '../actions/game_actions';
import * as GameUtils from '../../utils/game';
import * as Survive from '../../utils/survive';

/**
 * Advance a level in survival game
 *
 * @param {object} action there is no payload
 */
export function* advanceForSurvival(action) {
  const curEnergy = yield select(GameSelectors.energy);
  const curSurviveLvl = yield select(GameSelectors.surviveLevel);
  if (curSurviveLvl === Survive.SURVIVE_MAX_LEVEL) {
    yield put(GameActions.win());
  } else {
    const updates = GameUtils.advanceSurvival(curEnergy, curSurviveLvl);
    yield put(GameActions.update(updates));
  }
}

/**
 * Takes a letter out of the box and into the word.
 *
 * @param {object} action payload is index of letter
 */
export function* takeLetter(action) {
  const {index} = action.payload;
  const letters = yield select(GameSelectors.letters);
  const took = letters[index];

  yield put(GameActions.blankLetter(index));
  yield put(GameActions.appendToWord(took));
}

export function* takeVowel(action) {
  const {index} = action.payload;
  const vowels = yield select(GameSelectors.vowels);
  const taken = vowels[index];

  yield put(GameActions.blankVowel(index));
  yield put(GameActions.appendToWord(taken));
}

/**
 * Restores a letter back to the vowel pool or letter box.
 *
 * @param {object} action payload is word index and letter info
 */
export function* restore(action) {
  const {wordIndex, letterInfo} = action.payload;
  const word = yield select(GameSelectors.word);
  word.splice(wordIndex, 1);

  if (letterInfo.val.vowel) {
    yield put(GameActions.restoreVowel(letterInfo));
  } else {
    yield put(GameActions.restoreLetter(letterInfo));
  }
  yield put(GameActions.updateWord(word));
}

/**
 * Removes all letters from the current word and restore all the letters.
 * @param {object} action no payload
 */
export function* clear(action) {
  const word = yield select(GameSelectors.word);
  let wordIndex = word.length;
  while (wordIndex > 0) {
    wordIndex -= 1;
    const letterInfo = word[wordIndex];
    if (letterInfo.val.vowel) {
      yield put(GameActions.restoreVowel(letterInfo));
    } else {
      yield put(GameActions.restoreLetter(word[wordIndex]));
    }
  }
  yield put(GameActions.clearWord());
}

/**
 * Updates the list of best words.
 * @param {object} action no payload
 */
export function* updateBestWords(action) {
  const text = yield select(GameSelectors.text);
  const bestWords = yield select(GameSelectors.bestWords);
  const updatedBestWords = GameUtils.updateBestWords(bestWords, text);
  yield put(GameActions.setBestWords(updatedBestWords));
}

export function* vowel() {
  const isVowelMaxed = yield select(GameSelectors.isVowelMaxed);
  const energy = yield select(GameSelectors.energy);
  if (!isVowelMaxed && (energy > GameUtils.VOWEL_COST)) {
    yield put(GameActions.changeEnergy(energy - GameUtils.VOWEL_COST));
    const vowel = AlphaUtils.getVowel();
    yield put(GameActions.addVowel(vowel));
  }
}

/**
 * Action to play a word.
 * @param {object} action
 */
export function* go(action) {
  const isValid = yield select(GameSelectors.isValid);

  if (isValid) {
    // Get values
    const health = yield select(GameSelectors.health);
    const energy = yield select(GameSelectors.energy);
    const drain = yield select(GameSelectors.drain);
    const score = yield select(GameSelectors.score);
    const bestWords = yield select(GameSelectors.bestWords);
    const text = yield select(GameSelectors.text);
    const level = yield select(GameSelectors.level);

    // Damage Foe
    const newHealth = health - score;
    yield put(GameActions.setBestWords(GameUtils.updateBest(bestWords, text, score)));
    // Send Top Word
    // @TODO Make API Call
    if (newHealth <= 0) {
      if (level === Survive.SURVIVE_MAX_LEVEL) {
        // Send Top Game
        // @TODO Make API Call
        yield put(GameActions.playerWins());
      } else {
        yield put(GameActions.compressVowels());
        yield put(GameActions.wipeWord());
        yield put(GameActions.advanceForSurvival());
      }
    } else {
      // Foe strikes back
      const damage = drain;
      if (energy <= damage) {
        // Send Top Game
        // @TODO: Make API call
        yield put(GameActions.changeEnergy(energy - damage));
        yield put(GameActions.playerDefeated());
      } else {
        // Continue game
        yield put(GameActions.compressVowels());
        yield put(GameActions.wipeWord());
        yield put(GameActions.turn(newHealth));
        yield put(GameActions.attackDrain(drain));
      }
    }
  }
}
